'use strict';

const _ = require('underscore');
const Moment = require('moment');
const Mn = require('backbone.marionette');
const SVGRootView = require('common/ui/view/svg/root');
const DateTimeScale = require('common/ui/view/svg/gantt/date-time-scale');
const DateAxisView = require('common/ui/view/svg/gantt/date-axis');
const WeekAxisView = require('common/ui/view/svg/gantt/week-axis');
const MonthAxisView = require('common/ui/view/svg/gantt/month-axis');
const GanttBarListView = require('common/ui/view/svg/gantt/gantt-bar-list');
const ActionListView = require('common/ui/view/svg/gantt/action-list');
const ActionRepository = require('process/domain/repository/action/index');
const Template = require('balus/ui/template/body/project/content/gantt.hbs');

module.exports = Mn.View.extend({
    editMode: false,
    template: Template,
    ui: {
        scalePrevButton: '.scale-prev',
        scaleTodayButton: '.scale-today',
        scaleNextButton: '.scale-next',
        scaleDayButton: '.scale-day',
        scaleWeekButton: '.scale-week',
        scaleMonthButton: '.scale-month',
        scaleWholeButton: '.scale-whole'
    },
    events: {
        'click @ui.scalePrevButton': 'onScalePrev',
        'click @ui.scaleTodayButton': 'onScaleToday',
        'click @ui.scaleNextButton': 'onScaleNext',
        'click @ui.scaleDayButton': 'onScaleDay',
        'click @ui.scaleWeekButton': 'onScaleWeek',
        'click @ui.scaleMonthButton': 'onScaleMonth',
        'click @ui.scaleWholeButton': 'onScaleWhole'
    },

    initialize: function() {
        this._offsetX = 256;
        this._initial = true;
    },

    onAttach: function() {
        this.renderGantt();
        this.triggerMethod('close:nav');
    },

    getScale: function() {
        return this._scale;
    },

    setScale(scaleType, rootDateTime) {
        if(!rootDateTime) {
            rootDateTime = this._scale
                ? this._scale.getRootDateTime()
                : Moment(0, 'HH').subtract(3, 'days');
        }
        const offsetX = this._offsetX;
        let unitDays, scaleDays;

        if(scaleType == 'month') {
            unitDays = 30;
            scaleDays = 180;
        }
        if(scaleType == 'week') {
            unitDays = 7;
            scaleDays = 30;
        }
        if(scaleType == 'day') {
            unitDays = 1;
            scaleDays = 14;
        }
        this._scaleType = scaleType;

        this._scale = new DateTimeScale(unitDays, scaleDays, rootDateTime, offsetX);
    },

    _getMin(actions, method) {
        const action = actions
            .chain()
            .filter(a => a[method]())
            .min(a => a[method]())
            .value();
        if(action != Infinity) {
            return action[method]();
        }
        return null;
    },

    _getMax(actions, method) {
        const action = actions
            .chain()
            .filter(a => a[method]())
            .max(a => a[method]())
            .value();
        if(action != -Infinity) {
            return action[method]();
        }
        return null;
    },

    /**
     *
     * @param actions - Backbone.Collection
     */
    setWholeScale(actions) {
        if(actions.length == 0) {
            this.setScale('week');
            return;
        }

        const today = Moment(0, 'HH');
        const minStartDate = this._getMin(actions, 'getStartAt');
        const maxStartDate = this._getMax(actions, 'getStartAt');
        const minEndDate = this._getMin(actions, 'getEndAt');
        const maxEndDate = this._getMax(actions, 'getEndAt');

        let minDate;
        if(minStartDate && minEndDate) {
            minDate = minStartDate < minEndDate ?
                minStartDate :
                minEndDate;
        } else if(minStartDate) {
            minDate = minStartDate;
        } else if(minEndDate) {
            minDate = minEndDate;
        }

        let maxDate;
        if(maxStartDate && maxEndDate) {
            maxDate = maxStartDate > maxEndDate ?
                maxStartDate :
                maxEndDate;
        } else if(maxStartDate) {
            maxDate = maxStartDate;
        } else if(maxEndDate) {
            maxDate = maxEndDate;
        }

        let rootDateTime;
        if(minDate && minDate < today) {
            rootDateTime = minDate.clone();
        } else {
            rootDateTime = Moment(0, 'HH');
        }

        if(!maxDate) {
            this.setScale('week', rootDateTime);
            return;
        }

        const diffDays = maxDate.diff(minDate, 'day');
        if(diffDays < 21) {
            rootDateTime.subtract(3, 'days');
            this.setScale('week', rootDateTime);
            return;
        }
        rootDateTime.subtract(7, 'days');
        this.setScale('month', rootDateTime);
    },

    renderGantt: function() {
        const actionId = this.model.getActionID();
        ActionRepository.find(this.model).get(actionId)
            .then(action => {
                return action.getChildren();
            })
            .then(children => {
                if (this._rootView) {
                    this._rootView.destroy();
                }

                if(this._initial) {
                    this.setWholeScale(children);
                    this.activateScale(this._scaleType);
                    this._initial = false;
                }

                this._rootView = new SVGRootView({
                    viewPort: {
                        width: $(window).width(),
                        height: children.length * 36 + 54
                    }
                });

                $('.gantt').append(this._rootView.render().el);

                const rootView = this._rootView;

                const yLocator = function(model) {
                    return _.findIndex(children.sortBy(m => m.getSortPosition()), model) * 36 + 72;
                };

                const ganttSchedule = rootView.$el.append('g')
                    .classed('gantt-schedule', true);

                const axisView = this.getAxisView();

                ganttSchedule.append(axisView.render().el);

                const ganttBarListView = new GanttBarListView({
                    collection: children,
                    childViewOptions: {
                        scale: this.getScale(),
                        yLocator: yLocator,
                        editMode: this.getOption('editMode'),
                        context: this.getOption('context')
                    }
                });

                ganttSchedule.append(ganttBarListView.render().el);

                const ganttActionList = rootView.$el.append('g')
                    .classed('gantt-action-list', true);

                const actionListView = new ActionListView({
                    collection: children,
                    childViewOptions: {
                        context: this.getOption('context'),
                        yLocator: yLocator
                    }
                });

                ganttActionList.append(actionListView.render().el);
            });
    },

    getAxisView: function() {
        const offsetX = this._offsetX;

        if(this._scaleType === 'day') {
            return new DateAxisView({
                collection: this.getScale().getDateCollectionBetween(offsetX, $(window).width()),
                childViewOptions: {
                    scale: this.getScale()
                }
            });
        }
        if(this._scaleType === 'week') {
            return new WeekAxisView({
                collection: this.getScale().getDateCollectionBetween(offsetX, $(window).width()),
                childViewOptions: {
                    scale: this.getScale()
                }
            });
        }
        if(this._scaleType === 'month') {
            return new MonthAxisView({
                collection: this.getScale().getDateCollectionBetween(offsetX, $(window).width()),
                childViewOptions: {
                    scale: this.getScale()
                }
            });
        }
    },

    onScalePrev: function() {
        this.getScale().prev();
        this.renderGantt();
    },

    onScaleToday: function() {
        this.getScale().today();
        this.renderGantt();
    },

    onScaleNext: function() {
        this.getScale().next();
        this.renderGantt();
    },

    activateScale: function(scaleType) {
        this.$('.scale-button').removeClass('is-active');
        this.$(`.scale-${scaleType}`).addClass('is-active');
    },

    onScaleDay: function() {
        this.setScale('day');
        this.renderGantt();
        this.activateScale('day');
    },

    onScaleWeek: function() {
        this.setScale('week');
        this.renderGantt();
        this.activateScale('week');
    },

    onScaleMonth: function() {
        this.setScale('month');
        this.renderGantt();
        this.activateScale('month');
    },

    onScaleWhole: function() {
        const actionId = this.model.getActionID();
        ActionRepository.find(this.model).get(actionId)
            .then(action => {
                return action.getChildren();
            })
            .then(children => {
                this.setWholeScale(children);
                this.renderGantt();
                this.activateScale(this._scaleType);
            });
    },

    startEditMode: function() {
        this.editMode = true;
        this.renderGantt();
    },

    endEditMode: function() {
        this.editMode = false;
        this.renderGantt();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/content/gantt.js